import EventsWidgetStats from './EventsWidgetStats';

export default EventsWidgetStats;
